'use client';

import { toReadableDate } from '@/lib/dates';
import { getRelationFieldNames } from '@/requests/instanceMapper';
import {
  ApartmentListingApplicationConfig,
  type ApartmentListingApplication,
} from '@pigello/pigello-matrix';
import type { RelationFieldProps } from './types';

export const ApartmentListingApplicationItem: RelationFieldProps<ApartmentListingApplication> =
  {
    filters: [],
    nested: getRelationFieldNames(ApartmentListingApplicationConfig),
    renderItem: (item) => {
      return {
        title:
          item.tenantApplicant?.tenant?.communicationName ??
          'Saknar kommunikationsnamn',
        descriptionItems: (
          <div className='grid w-full'>
            <span>Intresseanmälde: {toReadableDate(item.createdAt)}</span>
          </div>
        ),
      };
    },
  };
